import React, { useState } from 'react'
import { Collapse } from 'react-bootstrap'
import { getI18nText } from '../../services/i18nService'

const Schematics = ({ resSchematicJpg, microcopy }) => {
  const [schematicsOpen, setSchematicsOpen] = useState(true)
  let images = resSchematicJpg.split('|')
  return (
    <div className="product-details__product-data--item" id="schematics">
      <p className="product-details__product-data--header font__heavy" id="button-schematic">
        <button
          className={`product-details__product-data--button ${schematicsOpen ? '' : 'collapsed'}`}
          type="button"
          aria-expanded={schematicsOpen}
          onClick={() => setSchematicsOpen(!schematicsOpen)}
          aria-controls="body-schematic"
        >
          {getI18nText(microcopy, 'product.schematicanddimensions')}
        </button>
      </p>
      <Collapse in={schematicsOpen}>
        <div
          id="body-schematic"
          className="product-details__product-data--collapse "
          aria-labelledby="button-schematic"
        >
          <div className="product-details__product-data--body">
            <div className="d-flex align-items-center">
              <div>
                <p>{getI18nText(microcopy, 'product.dimensions')}</p>
                <p>{getI18nText(microcopy, 'product.projection')}</p>
              </div>
            </div>
            {resSchematicJpg !== null && resSchematicJpg !== undefined
              ? images.map((element) => {
                  return (
                    <img
                      src={'https://cdn.norgren.com/images/' + element}
                      alt={getI18nText(microcopy, 'product.schematicanddimensions')}
                      className="mt-4 schematic-image image__fit--cover"
                    />
                  )
                })
              : null}
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default Schematics
